// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ThumbsScrollController_wrap__AY5Ek","controls":"ThumbsScrollController_controls__2n0uq"};